import React, { useState } from "react";
import StepHeader from "../common/StepHeader";
import PrimaryButton from "../common/PrimaryButton";
import { IconButton } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { Button } from "@mui/material";
import "./PromptPanel.css";
import Swal from "sweetalert2";

const PromptPanel = ({
    prompt,
    onPromptChange,

    imageModel,
    imageModels,
    onImageModelChange,

    examplePrompt,
    onExampleClick,
    onShuffleExample,

    suggestedPrompt,
    checkingPrompt,

    aspectRatio,
    onAspectRatioChange,

    onGenerate,
    onClear,
    isGenerated,

    loading,

    imagePreview,
    onImageChange,
    onRemoveImage,

    onClearAll
}) => {

    const [isHide, setIsHide] = useState(false);
    const [selectedImageModel, setSelectedImageModel] = useState(null);
    const [selectedSampleIndex, setSelectedSampleIndex] = useState(0);

    // const showUploadImageInfo = () => {
    //     Swal.fire({
    //         html: `
    //             <style>
    //                 .upload-info {
    //                     text-align: left;
    //                 }

    //                 @media (max-width: 576px) {
    //                     .upload-info {
    //                         text-align: center;
    //                     }
    //                 }
    //             </style>

    //             <div class="upload-info">
    //                 <p>
    //                     Optional: Upload an image to guide the composition or incorporate it into the final result (mention how to use it in your prompt).
    //                 </p>
    //             </div>
    //         `,
    //         confirmButtonText: "Got it",
    //         confirmButtonColor: "#ffa21f",
    //         customClass: {
    //             popup: "modal_class_success",
    //         },
    //     });
    // };

    const showUploadImageInfo = () => {
        Swal.fire({
            html: `
            <div class="upload-image-info-modal">

                <div class="upload-image-info-header">

                   

                    <div class="upload-image-info-heading">
                        <div class="upload-image-info-title">
                            Upload Image
                        </div>
                    </div>

                </div>

                <div class="upload-image-info-divider"></div>

                <div class="upload-image-info-section">

                    <span class="upload-image-info-label">Optional: </span><span class="upload-image-info-text ">
                        Upload an image to guide the composition or incorporate it into the final result (mention how to use it in your prompt).
                    </span>

                </div>
            </div>
        `,

            showConfirmButton: false,
            showCloseButton: true,

            allowOutsideClick: false,
            allowEscapeKey: true,

            buttonsStyling: false,

            customClass: {
                popup: "upload-image-info-popup",
                title: "upload-image-info-swal-title",
                htmlContainer: "upload-image-info-html",
                closeButton: "upload-image-info-close",
            },

            background: "#071522",
        });
    };

    // const showImageModelInfo = (model) => {
    //     Swal.fire({
    //         title: model.value,

    //         html: `
    //         <div class="image-model-info-modal">
    //             <div class="image-model-info-modal-header">
    //                 <div class="image-model-info-modal-heading">
    //                     <div class="image-model-info-modal-name">
    //                         ${model.label}
    //                     </div>
    //                 </div>
    //             </div>

    //             <div class="image-model-info-modal-divider"></div>

    //             <div class="image-model-info-modal-section">
    //                 <div class="image-model-info-modal-text">
    //                     ${model.info}
    //                 </div>
    //             </div>
    //         </div>
    //     `,

    //         showConfirmButton: false,

    //         showCloseButton: true,

    //         allowOutsideClick: false,
    //         allowEscapeKey: true,

    //         buttonsStyling: false,

    //         customClass: {
    //             popup: "image-model-info-popup",
    //             title: "image-model-info-title",
    //             htmlContainer: "image-model-info-html",
    //             closeButton: "image-model-info-close",
    //         },

    //         background: "#071522",
    //     });
    // };

    const showImageModelInfo = (model) => {
        setSelectedImageModel(model);
        setSelectedSampleIndex(0);
    };

    const closeImageModelInfo = () => {
        setSelectedImageModel(null);
        setSelectedSampleIndex(0);
    };

    return (
        <div className="prompt-panel">

            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                }}
            >
                <StepHeader
                    number={1}
                    title="Create"
                />

                <Button
                    onClick={loading ? undefined : onClearAll}
                    variant="outlined"
                    color="error"
                    size="small"
                    disableRipple={loading}
                    style={{
                        cursor: loading ? "not-allowed" : "pointer",
                        opacity: loading ? 0.5 : 1
                    }}
                >
                    Clear All
                </Button>
            </div>



            <div className="image-model-section">
                <div className="image-model-label-row">
                    <label>
                        Select Image AI Model
                        <span>*</span>
                    </label>

                    {/* {!imageModel && (
                        <span className="image-model-required">
                            Required
                        </span>
                    )} */}
                </div>

                <div className="image-model-grid">
                    {imageModels.map((model) => {
                        const isSelected = imageModel === model.value;

                        return (
                            // <button
                            //     key={model.value}
                            //     type="button"
                            //     className={`image-model-card ${isSelected ? "selected" : ""
                            //         }`}
                            //     onClick={() => onImageModelChange(model.value)}
                            //     disabled={loading}
                            //     aria-pressed={isSelected}
                            // >
                            //     <div className="image-model-card-top">
                            //         {/* <div className="image-model-icon">
                            //             {model.label.charAt(0)}
                            //         </div> */}
                            //         <div>
                            //             <div className="image-model-name">
                            //                 {model.label}
                            //             </div>

                            //             <div className="image-model-id">
                            //                 {/* {model.info} */}
                            //                 <p>{model.value}</p>
                            //                 <p style={{ color: "yellow" }} className="image-model-p" >Package 1: USD 0.20 per image</p>
                            //                 <p style={{ color: "#1AD772" }} className="image-model-p">Package 2: USD 0.16 per image</p>
                            //                 <p style={{ color: "#5F74F7" }} className="image-model-p">Package 3: USD 0.12 per image</p>

                            //                 <p className="mt-2">Approximately {model.timeSec} seconds of processing time is needed to generate 1 image.</p>
                            //             </div>

                            //             <div className="image-model-info">
                            //                 {/* Info Icon will be here on the right most side, while click on this icon open a modal with proper colorfull design and shows there the followings-
                            //                 1. Model name : model.value as the title 
                            //                 2. Info: model.info as the text */}
                            //             </div>
                            //         </div>

                            //         <div
                            //             className={`image-model-check ${isSelected ? "active" : ""
                            //                 }`}
                            //         >
                            //             {isSelected && "✓"}
                            //         </div>
                            //     </div>
                            // </button>

                            <div
                                key={model.value}
                                className={`image-model-card ${isSelected ? "selected" : ""
                                    }`}
                                onClick={() => {
                                    if (!loading) {
                                        onImageModelChange(model.value);
                                    }
                                }}
                                role="button"
                                tabIndex={loading ? -1 : 0}
                                aria-pressed={isSelected}
                                onKeyDown={(e) => {
                                    if (loading) return;

                                    if (e.key === "Enter" || e.key === " ") {
                                        e.preventDefault();
                                        onImageModelChange(model.value);
                                    }
                                }}
                            >
                                <div className="image-model-card-top">

                                    <div className="image-model-content">

                                        <div className="image-model-name">
                                            {model.label}
                                        </div>

                                        <div className="image-model-id">

                                            <p>
                                                {model.info}
                                            </p>

                                            <p
                                                style={{ color: "yellow" }}
                                                className="image-model-p"
                                            >
                                                Package 1: USD 0.20 per image
                                            </p>

                                            <p
                                                style={{ color: "#1AD772" }}
                                                className="image-model-p"
                                            >
                                                Package 2: USD 0.16 per image
                                            </p>

                                            <p
                                                style={{ color: "#5F74F7" }}
                                                className="image-model-p"
                                            >
                                                Package 3: USD 0.12 per image
                                            </p>

                                            <p className="mt-2">
                                                Approximately {model.timeSec} seconds
                                                of processing time is needed to generate 1 image.
                                            </p>

                                        </div>

                                    </div>

                                    <div className="image-model-card-actions">
                                        <div
                                            className={`image-model-check ${isSelected ? "active" : ""
                                                }`}
                                        >
                                            {isSelected && "✓"}
                                        </div>

                                        <IconButton
                                            type="button"
                                            className="image-model-info-btn"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                showImageModelInfo(model);
                                            }}
                                            disabled={loading}
                                            aria-label={`More information about ${model.label}`}
                                        >
                                            <InfoIcon fontSize="small" />
                                        </IconButton>

                                    </div>

                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            <div className="prompt-input-wrapper">

                <div className="d-flex justify-content-between align-items-center">
                    <label>
                        Prompt
                        <span>*</span>
                    </label>

                    <div>
                        <button
                            type="button"
                            className="va-clear-btn"
                            onClick={onClear}
                            disabled={loading || isGenerated}
                        >
                            Clear
                        </button>
                    </div>
                </div>

                <textarea
                    value={prompt}
                    onChange={(e) => onPromptChange(e.target.value)}
                    placeholder="Describe the image you want to generate..."
                />

            </div>

            {checkingPrompt && (
                <div className="checking-box">
                    Checking prompt...
                </div>
            )}

            {!checkingPrompt && !!prompt && !!suggestedPrompt && (
                <div className="suggested-box">

                    {/* Suggested Prompt Header */}
                    <div className="suggested-prompt-header mb-2">

                        <strong>
                            Suggested Prompt
                        </strong>

                        <button
                            type="button"
                            className="suggested-toggle-btn"
                            onClick={(e) => {
                                e.stopPropagation();
                                setIsHide((prev) => !prev);
                            }}
                            title={
                                isHide
                                    ? "Show suggested prompt"
                                    : "Hide suggested prompt"
                            }
                        >
                            {isHide ? (
                                <>
                                    <VisibilityIcon fontSize="small" />
                                    <span>Show</span>
                                </>
                            ) : (
                                <>
                                    <VisibilityOffIcon fontSize="small" />
                                    <span>Hide</span>
                                </>
                            )}
                        </button>

                    </div>

                    {/* Suggested Prompt Content */}
                    {!isHide && (
                        <p
                            className="suggested-prompt-text"
                            onClick={() =>
                                onPromptChange(suggestedPrompt, false)
                            }
                        >
                            {suggestedPrompt}
                        </p>
                    )}

                    {/* Hidden State */}
                    {isHide && (
                        <div className="suggested-prompt-hidden">
                            <span>
                                Suggested prompt is hidden
                            </span>

                            <button
                                type="button"
                                className="suggested-show-link"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setIsHide(false);
                                }}
                            >
                                Show prompt
                            </button>
                        </div>
                    )}

                </div>
            )}

            {!prompt && (
                <div
                    className="suggested-box"
                    onClick={onExampleClick}
                >

                    <div
                        className="prompt-example-top"
                        style={{ marginBottom: "10px" }}
                    >

                        <strong style={{ marginBottom: 0 }}>
                            What you can enter
                        </strong>

                        <button
                            type="button"
                            className="reload-example-btn"
                            onClick={(e) => {
                                e.stopPropagation();
                                onShuffleExample();
                            }}
                        >
                            ↻
                        </button>

                    </div>

                    <p>
                        {examplePrompt}
                    </p>

                </div>
            )}

            <div>
                <p
                    style={{
                        fontSize: "11px"
                    }}
                ><span
                    style={{
                        color: "yellow"
                    }}
                >Disclaimer: </span> AI-suggested prompts are automatically generated based on user input and do not reflect the views or opinions of the platform—please review and check the prompt before using.</p>
            </div>

            <div className="prompt-upload-section">

                <label>
                    Upload Image
                    <span> (Optional)</span>

                    <IconButton
                        size="small"
                        sx={{ color: "#ffa21f" }}
                        onClick={showUploadImageInfo}
                    >
                        <InfoIcon fontSize="small" />
                    </IconButton>
                </label>

                <div
                    className={`prompt-upload-area ${imagePreview ? "has-images" : ""
                        }`}
                    onClick={() => {
                        if (!imagePreview) {
                            document
                                .getElementById("prompt-image-upload")
                                .click();
                        }
                    }}
                >

                    <input
                        id="prompt-image-upload"
                        type="file"
                        accept="image/*"
                        onChange={onImageChange}
                        style={{ display: "none" }}
                    />

                    {imagePreview ? (
                        <div className="prompt-preview-container">

                            <div className="prompt-preview-item">

                                <img
                                    src={imagePreview}
                                    alt="Reference Preview"
                                    className="prompt-preview-img"
                                />

                                <button
                                    type="button"
                                    className="prompt-remove-btn"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onRemoveImage();
                                    }}
                                    title="Remove image"
                                >
                                    ✕
                                </button>

                            </div>

                        </div>
                    ) : (
                        <>
                            <div className="prompt-upload-icon">
                                📷
                            </div>

                            <div className="prompt-upload-text">
                                Drag & drop your image here or{" "}
                                <span>browse</span>
                            </div>

                            <div
                                className="prompt-upload-text mt-1"
                                style={{ fontSize: "12px" }}
                            >
                                Supports JPG, PNG, WEBP — 1 image
                            </div>
                        </>
                    )}

                </div>
            </div>
            <div className="aspect-ratio-section">
                <div className="aspect-ratio-label-row">
                    <label>
                        Aspect Ratio <span style={{ color: "#6D58FF" }} >*</span>
                    </label>
                </div>

                <div className="aspect-ratio-grid">
                    {["1:1", "3:2", "2:3", "16:9"].map((ratio) => {
                        const isSelected = aspectRatio === ratio;

                        return (
                            <button
                                key={ratio}
                                type="button"
                                className={`aspect-ratio-card ${isSelected ? "selected" : ""
                                    }`}
                                onClick={() => onAspectRatioChange(ratio)}
                                disabled={loading}
                            >
                                <div
                                    className={`aspect-ratio-preview ratio-${ratio.replace(
                                        ":",
                                        "-"
                                    )}`}
                                />

                                <div className="aspect-ratio-value">
                                    {ratio}
                                </div>
                            </button>
                        );
                    })}
                </div>
            </div>
            <div className="prompt-buttons">

                <PrimaryButton
                    variant="secondary"
                    onClick={onClear}
                    disabled={loading || isGenerated}
                >
                    Clear
                </PrimaryButton>
                <PrimaryButton
                    onClick={() => {
                        const missingFields = [];

                        if (!imageModel) {
                            missingFields.push("Image AI Model");
                        }
                        if (!prompt?.trim()) {
                            missingFields.push("Prompt");
                        }
                        if (!aspectRatio) {
                            missingFields.push("Aspect Ratio");
                        }
                        if (missingFields.length > 0) {
                            Swal.fire({
                                icon: "warning",
                                title: "Complete Your Setup",

                                html: `
                    <div class="generate-warning-content">
                        <div class="generate-warning-message">
                            Please complete the following before generating:
                        </div>

                        <div class="generate-missing-list">
                            ${missingFields
                                        .map(
                                            (field) => `
                                        <div class="generate-missing-item">
                                            <span class="generate-missing-icon">!</span>
                                            <span>${field}</span>
                                        </div>
                                    `
                                        )
                                        .join("")}
                        </div>
                    </div>
                `,

                                confirmButtonText: "Got it",
                                confirmButtonColor: "#6D5DF6",

                                customClass: {
                                    popup: "generate-warning-popup",
                                    title: "generate-warning-title",
                                    htmlContainer: "generate-warning-html",
                                    confirmButton: "generate-warning-button",
                                },

                                buttonsStyling: false,
                            });

                            return;
                        }

                        onGenerate();
                    }}
                    className={
                        !prompt?.trim() || !imageModel
                            ? "generate-button-incomplete"
                            : ""
                    }
                    disabled={loading || isGenerated}
                >
                    {loading ? "Generating..." : "Generate"}
                </PrimaryButton>

            </div>



            {selectedImageModel && (
                <div className="image-model-modal-overlay">
                    <div
                        className="image-model-modal"
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Header */}
                        <div className="image-model-modal-header">
                            <div>
                                <div className="image-model-modal-title">
                                    {selectedImageModel.label}
                                </div>

                                {/* <div className="image-model-modal-model">
                                    {selectedImageModel.value}
                                </div> */}
                            </div>

                            <button
                                type="button"
                                className="image-model-modal-close"
                                onClick={closeImageModelInfo}
                                aria-label="Close"
                            >
                                ✕
                            </button>
                        </div>

                        {/* Image */}
                        <div className="image-model-modal-image-wrapper">

                            <img
                                src={
                                    selectedImageModel.sample[
                                    selectedSampleIndex
                                    ]
                                }
                                alt={`${selectedImageModel.label} sample ${selectedSampleIndex + 1
                                    }`}
                                className="image-model-modal-image"
                            />

                            {/* Previous */}
                            {selectedImageModel.sample.length > 1 && (
                                <button
                                    type="button"
                                    className="image-model-slide-btn image-model-slide-prev"
                                    onClick={() =>
                                        setSelectedSampleIndex((prev) =>
                                            prev === 0
                                                ? selectedImageModel.sample.length - 1
                                                : prev - 1
                                        )
                                    }
                                    aria-label="Previous sample"
                                >
                                    ‹
                                </button>
                            )}

                            {/* Next */}
                            {selectedImageModel.sample.length > 1 && (
                                <button
                                    type="button"
                                    className="image-model-slide-btn image-model-slide-next"
                                    onClick={() =>
                                        setSelectedSampleIndex((prev) =>
                                            prev === selectedImageModel.sample.length - 1
                                                ? 0
                                                : prev + 1
                                        )
                                    }
                                    aria-label="Next sample"
                                >
                                    ›
                                </button>
                            )}
                        </div>

                        {/* Dots */}
                        {selectedImageModel.sample.length > 1 && (
                            <div className="image-model-modal-dots">
                                {selectedImageModel.sample.map((_, index) => (
                                    <button
                                        key={index}
                                        type="button"
                                        className={`image-model-modal-dot ${selectedSampleIndex === index
                                            ? "active"
                                            : ""
                                            }`}
                                        onClick={() =>
                                            setSelectedSampleIndex(index)
                                        }
                                        aria-label={`Show sample ${index + 1}`}
                                    />
                                ))}
                            </div>
                        )}

                        {/* Prompt */}
                        <div className="image-model-modal-prompt-section">
                            <div className="image-model-modal-prompt-label">
                                Prompt
                            </div>

                            <div className="image-model-modal-prompt">
                                {selectedImageModel.prompts[
                                    selectedSampleIndex
                                ]}
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
};

export default PromptPanel;